import React, { useEffect, useState } from 'react';
import HomeProjects from '../HomeProjects/HomeProjects';
import Intro from '../Intro/Intro';
import Services from '../Services/Services';
import './Home.css';
import HomeBlogs from '../HomeBlogs/HomeBlogs';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import { db } from "../lib/init-firebase";
import loader from "../../images/Loading_icon.gif"
import { collection, getDocs } from "firebase/firestore";
import Experience from '../Experience/Experience';

const Home = () => {

    const [introData, setIntroData] = useState({});

    useEffect(() => {
        const introRef = collection(db, "intro-card");
        getDocs(introRef)
            .then((response) => {
                const intro = response.docs.map((doc) => ({
                    data: doc.data(),
                }));
                setIntroData(intro[0].data);
            })
            .catch((error) => console.log(error.message));
    }, []);

    if (Object.keys(introData).length === 0) {
        return (
            <>
                <Navbar />
                <div style={{ height: "100vh", backgroundColor: "#1A3D5D" }} className="d-flex justify-content-center align-items-center">
                    <img src={loader} width="100px" alt="" />
                </div>
            </>
        )
    }

    return (
        <div className="header">
            <Navbar />
            <Intro introData={introData} />
            <Experience />
            <Services />
            <HomeProjects />
            <HomeBlogs />
            <Footer />
        </div>
    );
};

export default Home;